import React from "react";
import { Select, MenuItem, Typography } from "@material-ui/core";

export const dropRenderer = (
    value,
    name,
    fieldUpdateHandler,
    mutable,
    defaultValues,
) => {
    let availableOptsIdx = [];

    const curCategory =
        defaultValues?.length > 0 &&
        defaultValues.find((defValue) => defValue.id === value);

    const itemsToRender =
        defaultValues?.length > 0 &&
        defaultValues.map((defVal) => (
            <MenuItem key={defVal.id} value={defVal.id}>
                {defVal.name}
            </MenuItem>
        ));

    if (defaultValues && defaultValues?.length > 0) {
        availableOptsIdx = defaultValues.map((defVal) => defVal.id);
    }

    return (
        <React.Fragment>
            {defaultValues && defaultValues?.length > 0 && value ? (
                mutable ? (
                    <Select
                        value={availableOptsIdx.includes(value) ? value : ""}
                        onChange={(e) => {
                            fieldUpdateHandler(name, e.target.value);
                        }}
                    >
                        {itemsToRender}
                    </Select>
                ) : (
                    <Typography>
                        {curCategory?.name
                            ? curCategory.name
                            : "Нет данных о выбранной категории"}
                    </Typography>
                )
            ) : (
                <Typography>Нет данных по категориям</Typography>
            )}
        </React.Fragment>
    );
};
